<div class="gradient-border-card">
  <div class="p-4">
    <h6 class="fw-bold headings-primary mb-3">Summary Snapshot</h6>

    <div class="table-responsive">
      <table class="w-100 summary_table mb-0">
        <tbody>
          <tr 
            v-for="(item, index) in summary_items"
            :key="index"
            class="summary_row"
          >
            <td class="py-3 headings-primary-50 text-xxs">
              {{ item.label }}
            </td>

            <td class="py-3 text-end fw-bold headings-primary text-xs">
              {{ item.value }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>